
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class vSelectFx extends Vue {
  element: any;
  SelectFx: any;
  selectFxInstance: any;

  @Prop() value: any;
  @Prop() options: any;

  @Watch("options")
  onOptionsChanged(val: any, oldVal: any) {
    if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
      Vue.nextTick(() => {
        let parentContainer = this.element.parentNode;
        parentContainer.parentNode.appendChild(this.element);
        parentContainer.parentNode.removeChild(parentContainer);

        this.selectFxInstance = new this.SelectFx(this.element);
      });
    }
  }

  handleInput(event: Event) {
    this.$emit("change", (event.target as HTMLSelectElement).value);
  }

  mounted() {
    Vue.nextTick(() => {
      this.element = this.$refs["selectFx"];
      this.SelectFx = (<any>$(window)).get(0).SelectFx;

      this.selectFxInstance = new this.SelectFx(this.element);
    });
  }
}
